<template>
  <CRow>
    <CCol col="12" lg="12">
      <CAlert color="danger" closeButton :show.sync="dismissCountDown" fade>
        {{ err_msg }}
      </CAlert>
      <CCard>
        <CCardHeader>
          <strong>{{ $lang.instituteChain.crud.view }}</strong>
        </CCardHeader>
        <CCardBody>
          <table class="table table-bordered">
            <tr>
              <th>{{ $lang.instituteChain.form.code }}</th>
              <td>{{ instituteChain.code }}</td>
            </tr>
            <tr>
              <th>{{ $lang.instituteChain.form.type }}</th>
              <td>{{ instituteChain.type.value }}</td>
            </tr>
            <tr>
              <th>{{ $lang.instituteChain.form.is_flat }}</th>
              <td v-if="instituteChain.is_flat === 1">Yes</td>
              <td v-if="instituteChain.is_flat === 0">No</td>
            </tr>
            <tr :hidden="persontageField">
              <th>{{ $lang.instituteChain.form.percentage }}</th>
              <td>{{ instituteChain.percentage }}</td>
            </tr>
            <tr :hidden="amountField">
              <th>{{ $lang.instituteChain.form.amount }}</th>
              <td>{{ instituteChain.amount }}</td>
            </tr>
            <tr>
              <th>{{ $lang.instituteChain.form.start_date }}</th>
              <td>{{ getDateWithFormat(instituteChain.start_date) }}</td>
            </tr>
            <tr>
              <th>{{ $lang.instituteChain.form.end_date }}</th>
              <td>{{ getDateWithFormat(instituteChain.end_date) }}</td>
            </tr>
            <tr>
              <th>{{ $lang.instituteChain.form.noOfUsers }}</th>
              <td v-if="instituteChain.noOfUsers !== '' ">{{ instituteChain.noOfUsers }}</td>
              <td v-if="instituteChain.noOfUsers === '' ">--</td>
            </tr>
            <tr :hidden="userField">
              <th>{{ $lang.instituteChain.form.user }}</th>
              <td>{{ instituteChain.user }}</td>
            </tr>
            <tr :hidden="companyField">
              <th>{{ $lang.instituteChain.form.company_name }}</th>
              <td>{{ instituteChain.companyName }}</td>
            </tr>
            <tr :hidden="companyField">
              <th>{{ $lang.instituteChain.form.email }}</th>
              <td>{{ instituteChain.email }}</td>
            </tr>
            <tr :hidden="companyField">
              <th>{{ $lang.instituteChain.form.address }}</th>
              <td>{{ instituteChain.address }}</td>
            </tr>
            <tr :hidden="companyField">
              <th>{{ $lang.instituteChain.form.contact_no }}</th>
              <td>{{ instituteChain.mobile }}</td>
            </tr>
            <tr :hidden="companyField">
              <th>{{ $lang.instituteChain.form.cp_name }}</th>
              <td>{{ instituteChain.cp_name }}</td>
            </tr>
            <tr :hidden="companyField">
              <th>{{ $lang.instituteChain.form.cp_contact_no }}</th>
              <td>{{ instituteChain.cpMobile }}</td>
            </tr>
            <tr :hidden="companyField">
              <th>{{ $lang.instituteChain.form.cp_email }}</th>
              <td>{{ instituteChain.cp_email }}</td>
            </tr>
          </table>
        </CCardBody>
        <CCardFooter>
          <CButton color="danger" size="sm" @click="cancel">
            <CIcon name="cil-ban"/>
            {{ $lang.buttons.general.crud.cancel }}
          </CButton>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import Vue from "vue";
import VueForm from "vue-form";
import store from "/src/store/store.js";
import {instituteChain, users} from "/src/store/url.js";
import {Mixin} from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import VueNotifications from "vue-notifications";
import VueToasted from "vue-toasted";
import moment from "moment";
import VueTelInput from "vue-tel-input-fix";
import "vue-tel-input-fix/dist/vue-tel-input.css";

function toast({title, message, type, timeout, cb}) {
  if (type === VueNotifications.types.warn) type = "show";
  return Vue.toasted[type](message, {
    duration: timeout,
    position: "top-left",
  });
}

Vue.use(VueToasted);
Vue.use(VueTelInput);
const optionss = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast,
  position: "top-center",
};
Vue.use(VueNotifications, optionss);
Vue.use(VueForm, options);

export default {
  name: "instituteChainCreate",
  mixins: [Mixin],
  data() {
    return {
      bindProps: {
        mode: "international",
        placeholder: "Contact No.",
        defaultCountry: "IN",
        dropdownOptions: {
          showFlags: true,
        },
        validCharactersOnly: true,
      },
      submitted: false,
      amountField: "",
      persontageField: "",
      userField: "",
      companyField: "",
      err_msg: "",
      dismissCountDown: 0,
      self: this,
      module: instituteChain,
      moduleUser: users,
      userOptions: [],
      editId: this.$route.params.id,
      instituteChain: {
        is_flat: "",
        percentage: "",
        amount: "",
        user: "",
        type: "",
        start_date: "",
        end_date: "",
        code: "",
        companyName: "",
        email: "",
        address: "",
        cp_email: "",
        cpCountryCode: "",
        cpMobile: "",
        cp_name: "",
        countryCode: "",
        mobile: "",
      },
      typeOptions: [
        {value: "Internal", label: "Internal"},
        {value: "External", label: "External"},
      ],
    };
  },
  mounted() {
    let self = this;
    store.commit("showLoader", false); // Loader Off
    self.dismissCountDown = 0;
    axios.get(this.listUrlApi(this.moduleUser)).then((response) => {
      response.data.data.map(function (value, key) {
        self.userOptions.push({value: value.id, label: value.username});
      });
    });

    axios
        .get(this.viewUrlApi(this.module, self.editId))
        .then((response) => {
          let instituteChain = response.data.data;
          self.instituteChain.is_flat = instituteChain.isFlat;
          if (instituteChain.isFlat === 1) {
            self.amountField = false;
            self.persontageField = true;
            self.instituteChain.percentage = "";
            self.instituteChain.amount = instituteChain.amount;
          } else {
            self.amountField = true;
            self.persontageField = false;
            self.instituteChain.percentage = instituteChain.percentage;
            self.instituteChain.amount = "";
          }
          if (instituteChain.type === "External") {
            self.userField = true;
            self.companyField = false;
            self.instituteChain.user = {};
            self.instituteChain.companyName = instituteChain.instituteChainCompanies.companyName;
            self.instituteChain.email = instituteChain.instituteChainCompanies.email;
            self.instituteChain.address = instituteChain.instituteChainCompanies.address;
            self.instituteChain.mobile =
                instituteChain.instituteChainCompanies.contactNoCode + " " + instituteChain.instituteChainCompanies.contactNo;
            self.instituteChain.cpMobile =
                instituteChain.instituteChainCompanies.cpContactNoCode + " " + instituteChain.instituteChainCompanies.cpContactNo;
            self.instituteChain.cp_email = instituteChain.instituteChainCompanies.cpEmail;
            self.instituteChain.cp_name = instituteChain.instituteChainCompanies.cpName;
          } else {
            self.userField = false;
            self.companyField = true;
            let userIds = [];
            instituteChain.userList.map(function (value, key) {
              userIds[key] = value.label;
            });
            self.instituteChain.user = userIds.join(", ");
            self.instituteChain.companyName = "";
            self.instituteChain.email = "";
            self.instituteChain.address = "";
            self.instituteChain.cpCountryCode = "";
            self.instituteChain.cpMobile = "";
            self.instituteChain.cp_email = "";
            self.instituteChain.cp_name = "";
            self.instituteChain.countryCode = "";
            self.instituteChain.mobile = "";
          }
          self.instituteChain.type = {value: instituteChain.type, label: instituteChain.type};
          self.instituteChain.start_date = instituteChain.startDate;
          self.instituteChain.end_date = instituteChain.endDate;
          self.instituteChain.code = instituteChain.code;
          self.instituteChain.noOfUsers = instituteChain.noOfUsers;
          store.commit("showLoader", false); // Loader Off
        })
        .catch(function (error) {
          store.commit("showLoader", false); // Loader Off
        });
  },
  methods: {
    getHumanDate: function (date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    sendAlert() {
      this.$root.$emit("alert", "test1", "test2");
    },
    cancel() {
      this.usersOpened
          ? this.$router.go(-1)
          : this.$router.push({path: "/instituteChain"});
    },
  },
};
</script>
<style>
div .error {
  color: red;
}

.hasError label {
  color: red;
}
</style>
